import {
  ListUsersV2CommandInput,
  ListUsersV2CommandOutput,
} from '@amzn/gbsa-orbit-typescript-client';
import { QueryKey, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { userKeys } from 'src/data/api/orbit-service-ts/user/queries/keys';
import { userService } from 'src/data/api/orbit-service-ts/user/userService';

export const useUserListQuery = <TData = ListUsersV2CommandOutput>(
  input: ListUsersV2CommandInput,
  options?: Omit<
    UseQueryOptions<ListUsersV2CommandOutput, Error, TData, QueryKey>,
    'queryKey' | 'queryFn'
  >,
) =>
  useQuery({
    ...options,
    queryKey: userKeys.list(input),
    queryFn: async () => {
      return await userService.list(input);
    },
  });
